import secret from "../../secret.json";

// 학생 포인트 · 상점(api/reward). 로그인이 없어 주소의 session(학생번호:고유코드)으로 본인을 밝힌다.
// 공용 apiClient 는 실패하면 무조건 "오류가 발생했습니다" 창을 띄워서, "포인트가 모자라요" 같은
// 서버 안내를 보여 줄 수 없다. 그래서 여기서는 fetch 로 직접 부르고 서버 문구를 그대로 쓴다.
const BASE = `${secret.API_BASE_URL.replace(/\/$/, "")}/api/v1/reward/student`;

export const studentCredential = () => {
  try {
    const session = new URLSearchParams(window.location.search).get("session");
    const [studentId, randomCode] = atob(session || "").split(":");
    return studentId && randomCode ? { student_id: studentId, random_code: randomCode } : null;
  } catch {
    return null;
  }
};

const request = async (path, { method = "GET", body } = {}) => {
  const credential = studentCredential();
  if (!credential) throw new Error("잘못된 주소입니다.");
  const query = method === "GET" ? `${path.includes("?") ? "&" : "?"}${new URLSearchParams(credential)}` : "";
  const response = await fetch(`${BASE}${path}${query}`, {
    method,
    headers: { "Content-Type": "application/json" },
    body: method === "GET" ? undefined : JSON.stringify({ ...credential, ...(body || {}) }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || "잠시 뒤 다시 해 주세요.");
  return data;
};

export const fetchPointSummary = () => request("/summary");
export const fetchPointHistory = () => request("/history");
export const fetchStore = () => request("/store");
export const exchangeProduct = (productId, requestKey) =>
  request("/exchange", { method: "POST", body: { product_id: productId, request_key: requestKey } });
export const fetchCouponList = () => request("/coupons");
export const fetchCoupon = (orderId) => request(`/coupons/${orderId}`);
export const searchClassmates = (keyword) => request(`/classmates?q=${encodeURIComponent(keyword)}`);
export const fetchGroupList = () => request("/group");
export const startGroupPurchase = (productId, friendIdList) =>
  request("/group", { method: "POST", body: { product_id: productId, friend_id_list: friendIdList } });
export const respondGroupPurchase = (groupId, isAgreed) =>
  request(`/group/${groupId}/respond`, { method: "POST", body: { is_agreed: isAgreed } });

// 같은 교환이 두 번 들어가지 않게 누를 때마다 새 번호를 만든다(서버가 이 번호로 한 번만 처리한다).
export const newRequestKey = () =>
  (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;
